<template>
  <div class="qa-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.qa') }}</span>
    </div>
    <div class="page-title">
      {{ $t('qa.title') }}
      <div class="search-block hide-on-pad">
        <div class="search-title color-orange">{{ $t('qa.help') }}</div>
        <div class="search-input-block">
          <input type="text" :placeholder="$t('qa.help_placeholder')" v-model="searchString">
          <div class="btn btn-orange" @click="searchQa">{{ $t('btns.search') }}</div>
        </div>
      </div>
      <div class="search-block-mobile">
        <div class="search-input-block-mobile show-on-pad">
          <input type="text" v-model="searchString" @change="handleMobileSearchChange">
          <Icon type="search"></Icon>
          <label for="">{{ $t('btns.search') }}</label>
        </div>
      </div>
      <div class="cates" v-loading="loadingCate">
        <div class="cate-item" :class="{ active: activeCate==item.id }" v-for="item in qaCate" :key="'qacate_'+item.id" @click="handleSelectCate(item.id)">{{ item.name }}</div>
      </div>
    </div>
    <div class="page-container">
      <!-- <div class="page-left hide-on-pad">
        <user-side-menu page="favorite"/>
      </div> -->
      <div class="page-right" v-loading="loadingQalist">
        <div class="qa-list" v-show="questions">
          <el-collapse v-model="activeNames">
            <el-collapse-item :title="'Q'+(index2+1)+'. '+item.title" :name="index2" v-for="(item,index2) in questions" :key="index2+'_qa_cate_item'">
              <div class="content">
                {{ item.content }}
              </div>
              <!-- <div class="btn btn-outline-orange" @click="handleGoToDetail(1)">详细</div> -->
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="no-data" v-show="!questions || questions.length==0">
          <p v-show="firstInter">{{ $t('qa.first_inter') }}</p>
          <div class="tac" v-show="!firstInter">
            <p class="mb-10">{{ $t('qa.no_result1') }}</p>
            <p>{{ $t('qa.no_result2') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
                         
<script>
// import userSideMenu from '../../components/UserSideMenu'
import { getQuestions, getQACate, searchQ } from '../../api'
  export default {
    name: 'qa',
    data() {
      return {
        firstInter: true,
        searchString: '',
        count: 1000000,
        loadingQalist: false,
        questions: '',
        qaCate: [],
        activeCate: '',
        loadingCate: true,
        activeNames: [],
      }
    },
    components: {
      // userSideMenu
    },
    async created() {
      const res = await getQACate();
      console.log('res',res);
      this.loadingCate = false;
      this.qaCate = res.list;
    },
    methods: {
      async getList() {
        this.loadingQalist = true;
        this.activeNames = [];
        const { list } = await getQuestions({ ind: this.activeCate });
        this.questions = list;
        this.firstInter = false;
        this.loadingQalist = false;
      },
      handleGoToDetail(id) {
        // let routeData = this.$router.resolve({ name: 'QADetail', query: { id } });
        // window.open(routeData.href, '_blank');
        this.$router.push({ name: 'QADetail', query: { id } });
      },
      handleSelectCate(id) {
        this.activeCate = id;
        this.getList();
      },
      handleMobileSearchChange(e) {
        console.log(e.target.value);
        if(e.target.value){
          e.target.classList.add('hasV');
        }else{
          e.target.classList.remove('hasV');
        }
        // 执行搜寻api
        this.searchQa();
      },
      async searchQa() {
        this.activeCate = '';
        this.loadingQalist = true;
        this.activeNames = [];
        const res = await searchQ({ keyword: this.searchString });
        console.log('qa search res',res);
        const { list } = res;
        this.questions = list;
        this.firstInter = false;
        this.loadingQalist = false;
      }
    }
  }
</script>

<style lang="less" scoped>
.qa-page {
  .page-container {
    padding-top: 0;
  }
  .page-title {
    padding: 0;
    margin-bottom: 0;
    @media (max-width: 992px) {
      padding-top: 20px;
    }
  }
  .page-right  {
    padding-top: 30px;
    width: 100%;
  }
  .search-block {
    width: 100%;
    background: #E4E4E4;
    font-size: 1rem;
    font-weight: 100;
    letter-spacing: 2px;
    padding: 20px 90px 50px 90px;
    margin-top: 30px;
    .search-title {
      margin-bottom: 20px;
    }
    .search-input-block {
      display: flex;
      input {
        border: unset;
      }
      .btn {
        width: 190px;
      }
    }
  }
  .search-block-mobile {
    padding: 0 20px;
    padding-bottom: 20px;
  }
  .search-input-block-mobile {
    background: #E6E6E6;
    position: relative;
    margin-top: 20px;
    border-radius: 5px;
    font-size: 1rem;
    & /deep/ .cloud-icon {
      width: 20px;
      height: 20px;
      pointer-events: none;
      position: absolute;
      top: 50%;
      left: 49%;
      transform: translate(-100%,-50%);
      transition: .5s;
      svg {
        fill: #656565;
      }
    }
    label {
      position: absolute;
      pointer-events: none;
      top: 50%;
      left: 51%;
      transform: translate(-0%,-50%);
    }
    input {
      width: 100%;
      border: unset;
      background: unset;
      padding: 15px;
      padding-left: 40px;
      &:focus+.cloud-icon {
        left: 10px;
        transform: translate(-0%,-50%);
      }
      &:focus~label {
        display: none;
      }
      &.hasV+.cloud-icon {
        left: 10px;
        transform: translate(-0%,-50%);
      }
      &.hasV~label {
        display: none;
      }
    }
  }
  .cates {
    display: flex;
    flex-wrap: wrap;
    font-size: 1rem;
    letter-spacing: 0;
    @media (max-width: 992px) {
      padding: 0 20px;
    }
    .cate-item {
      cursor: pointer;
      border: 1px solid #999;
      color: #999;
      margin-bottom: 20px;
      margin-right: 14px;
      padding: 5px;
      transition: all .3s;
      &.active {
        color: #FF5214;
        border: 1px solid #FF5214;
        filter: drop-shadow(2px 2px 2px rgba(0,0,0,.4));
        transform: translate(-2px, -2px);
      }
    }
  }
  .qa-list {
    .collapse-title {
      font-size: 1.2rem;
      font-weight: 400;
      margin-bottom: 10px;
      @media (max-width: 992px) {
        text-align: center;
      }
    }
    ::v-deep {
      .el-collapse {
        border-top: unset;
        margin-bottom: 60px;
        @media (max-width: 992px) {
          border-top: 2px solid #EBEEF5;
        }
      }
      .el-collapse-item__wrap {
        border-color: RGBA(174, 174, 174, .5);
        border-width: 2px;
        @media (max-width: 992px) {
          border-color: #EBEEF5;
        }
      }
      .el-collapse-item__header {
        font-size: 1.3rem;
        border-bottom-color: RGBA(174, 174, 174, .5);
        border-width: 2px;
        height: auto;
        line-height: 2rem;
        padding: 10px 0;
        // padding-bottom: 0;
        @media (max-width: 992px) {
          border-bottom-color: #EBEEF5;
          color: #999;
        }
        &.is-active {
          border-bottom-color: transparent;
          color: #FF5214;
        }
      }
      .el-collapse-item__content {
        padding-right: 160px;
        
        // padding-bottom: 0;
        position: relative;
        min-height: 40px;
        .content {
          padding-top: 15px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .btn {
          position: absolute;
          width: 100px;
          right: 40px;
          bottom: 25px;
          padding: 5px;
        }
      }
      .el-collapse-item__wrap {
        // padding-bottom: 25px;
      }
    }
  }
}
</style>